module.exports = __webpack_public_path__ + "img/icona3_old.07ab612b.png";